<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室建设项目处理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.applyStatus1" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目性质">
          <el-select v-model="formInline.character" clearable filterable placeholder="请选择项目性质">
            <el-option v-for="item in $store.state.characters" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.type" clearable filterable placeholder="请选择类型">
            <el-option v-for="item in $store.state.characterTypes" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="training_name" label="建设项目名称" width="160">
      </custom-table-column>
      <custom-table-column label="审核状态" width="150" prop="status" :formatter="format_status">
      </custom-table-column>
      <custom-table-column prop="fail_reason" label="处理结果" width="160">
      </custom-table-column>
      <custom-table-column prop="person" label="项目负责人" width="100">
      </custom-table-column>
      <custom-table-column prop="address" label="项目地点" min-width="220">
      </custom-table-column>
      <custom-table-column prop="area" label="使用面积(m²)" width="120">
      </custom-table-column>
      <custom-table-column prop="character_text" label="项目性质" width="120">
        <!-- <template slot-scope="scope">
          <span v-for="item in $store.state.characters" :key="item.value" >{{ scope.row.character==item.value?item.label:'' }}</span>
        </template> -->
      </custom-table-column>
      <custom-table-column prop="type_text" label="项目类型" width="120">
        <!-- <template slot-scope="scope">
          <span v-for="item in $store.state.characterTypes" :key="item.value" >{{ scope.row.type==item.value?item.label:'' }}</span>
        </template> -->
      </custom-table-column>
      <custom-table-column prop="type" label="面向院系专业" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.structure_1 }}-{{ scope.row.major }}</span>
        </template>
      </custom-table-column>
      <custom-table-column prop="investment_num" label="预计投资(万元)" width="150">
      </custom-table-column>
      <custom-table-column prop="start_time" label="开始时间" width="180">
      </custom-table-column>
      <custom-table-column prop="end_time" label="结束时间" width="180">
      </custom-table-column>
      <custom-table-column label="文件" width="150">
        <template slot-scope="scope" v-if="scope.row.annexes">
          <el-link type="primary" v-for="(item, index) in scope.row.annexes.split(',')" :href="item" :key="index"
            target="_blank">{{ $until.getFileName(item) }}</el-link>
        </template>
      </custom-table-column>
      <!-- <custom-table-column prop="desc" label="备注" min-width="200">
      </custom-table-column> -->
      <custom-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <!-- <el-button @click="handleAddItem(scope.row.id)" type="text" size="small">添加条目</el-button> -->
          <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
          <el-button v-if="scope.row.status == 0" @click="handleOper(scope.row.id, 1)" type="text"
            size="small">通过</el-button>
          <el-button v-if="scope.row.status == 0" @click="handleOper(scope.row.id, 2)" type="text"
            size="small">否决</el-button>
          <el-button @click="handleAddMessage(scope.row.id)" type="text" size="small">评审消息</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="operDialogVisible" width="530px">
      <el-form :model="ruleOperForm" ref="ruleOperForm" label-width="100px" class="demo-ruleForm">
        <el-form-item v-if="ruleOperForm.status == 2" label="处理结果" prop="fail_reason"
          :rules="[{ required: true, message: '请输入处理结果', trigger: 'blur' }]">
          <el-input type="textarea" v-model="ruleOperForm.fail_reason" placeholder="请输入处理结果" style="width:352px;"
            :rows="5"></el-input>
        </el-form-item>
        <el-form-item v-else label="处理结果" prop="fail_reason">
          <el-input type="textarea" v-model="ruleOperForm.fail_reason" placeholder="请输入处理结果" style="width:352px;"
            :rows="5"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleOperForm', setStatus)">确认</el-button>
          <el-button @click="resetForm('ruleOperForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="评审消息" :visible.sync="detailDialogVisible" width="746px">
      <div>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleAddItem">添加消息</el-button>
          </el-form-item>
        </el-form>
      </div>
      <custom-table :data="tableData1" ref="table" border style="width: 100%">
        <custom-table-column prop="content" label="消息内容" min-width="200">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleDeletItem(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <el-dialog :close-on-click-modal="false" :title="itemTitle" :visible.sync="innerDialogVisible" width="524px"
        append-to-body>
        <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
          <el-form-item label="问题描述" prop="content">
            <el-input type="textarea" placeholder="请输入问题描述" :rows="5" v-model="ruleForm1.content"
              style="width:352px;"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="typee == 'add'"
              @click="submitFormByFun('ruleForm1', addCheckItem)">确认</el-button>
            <el-button @click="resetItemForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinFormatter],
  data() {
    return {
      props: {
        label: 'name',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        status: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },
      ruleOperForm: {
        id: '',
        status: '',
        fail_reason: '',
      },
      formInline1: {},
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      operDialogVisible: false,
      innerDialogVisible: false,
      detailDialogVisible: false,
      ruleForm1: {
        id: '',
        content: '',
      },
      itemTitle: '',
      typee: 'add',
      rules1: {
        content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }],
      },
      tableData1: [],
    };
  },
  created() { },
  mounted() {
    // this.getList();
    // this.$store.dispatch('getStandards');
  },
  methods: {
    handleAddMessage(id) {
      this.ruleForm1.id = id;
      this.detailDialogVisible = true;
      this.getItemList(id)
    },
    async addCheckItem() {
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/msg/add`, 'post', this.ruleForm1);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '添加消息成功！',
        });
        this.clearState1();
      }
    },
    handleDeletItem(id) {
      this.confirmBox('warning', `此操作将删除该消息，是否继续`, { id }, this.deleteItem);
    },
    async deleteItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/msg/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.getItemList(this.ruleForm1.id);
      }
    },
    clearState1() {
      this.resetForm('ruleForm1');
      this.ruleForm1.content = '';
      this.innerDialogVisible = false;
      this.getItemList(this.ruleForm1.id);
    },
    async getItemList(id) {
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/msg/list`, 'get', { id });
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData1 = res.data.data;
      }
    },
    handleAddItem() {
      this.innerDialogVisible = true;
      this.typee = 'add';
      this.itemTitle = '新增评审消息';
      this.ruleForm1.content = '';
    },
    resetItemForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleOper(id, status) {
      this.ruleOperForm.id = id;
      this.ruleOperForm.status = status;
      this.operDialogVisible = true;
      this.$nextTick(() => {
        this.resetForm('ruleOperForm')
      })
    },
    async setStatus() {
      let params = this.$until.deleteNullPrototype(this.ruleOperForm);
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/process`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.operDialogVisible = false;
        this.ruleOperForm = {
          id: '',
          status: '',
          fail_reason: '',
        };
        this.getList();
      }
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/room/apply/self/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;

  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
    box-shadow: 0 0 1px 1px #ccc;
    padding: 0 8px;
  }
}
</style>
